<div class="wrapper">
    <div class="content">
        <div class="blue header">
            Ok {{ currentUser.name | singleName: 'first' }}, I'm ready to send out the
            <span *ngIf="isUpdatingMeeting">updated</span> invitations!
        </div>
        <p class="content__body">
            I'll email the attendees and let them know the meeting has been
            {{ isUpdatingMeeting ? 'rescheduled' : 'scheduled' }} to:
            <strong>{{ wizardService.options.dateStart | date: 'MMMM d' }}</strong> at
            <strong>{{ wizardService.options.timeStart | date: 'h:mm a' }}</strong
            >.
        </p>

        <div *ngIf="!isUpdatingMeeting" class="ui list">
            <div class="ui tiny header">Invitees:</div>
            <ng-container *ngFor="let contact of selectedContacts">
                <div class="item">
                    {{ contact.name }}
                    <span class="light">({{ contact.defaultEmail || (contact.email && contact.email[0]) }})</span>
                    <div *ngIf="contact | checkIsVIP: vipContacts" class="vip">
                        <i class="ui star icon"></i>
                        <span class="vip__tooltip">VIP</span>
                    </div>
                </div>
            </ng-container>
        </div>
        <div *ngIf="availabilityUsers?.length" class="ui list">
            <div class="ui tiny header">
                This is a {{ availabilityTypeText }} meeting, based on the availability of:
            </div>
            <ng-container *ngFor="let member of availabilityUsers">
                <div class="item">
                    {{ member.name }}
                    <span class="light">({{ member.defaultEmail || member.email[0] }})</span>
                </div>
            </ng-container>
        </div>
        <ng-container *ngIf="timezone">
            <p class="timezone">All times shown in {{ timezone | tzName }}</p>
        </ng-container>
    </div>
    <img class="ui medium image" src="/assets/images/time-selection.svg" />
</div>
